export const UserloyalityLogRptConstants ={
    GETALL_REQUEST: 'USERLOYALITYLOG_GETALL_REQUEST',
    GETALL_SUCCESS: 'USERLOYALITYLOG_GETALL_SUCCESS',
    GETALL_FAILURE: 'USERLOYALITYLOG_GETALL_FAILURE',

    GETEXPORT_REQUEST: 'USERLOYALITYLOG_GETEXPORT_REQUEST',
    GETEXPORT_SUCCESS: 'USERLOYALITYLOG_GETEXPORT_SUCCESS',
    GETEXPORT_FAILURE: 'USERLOYALITYLOG_GETEXPORT_FAILURE',

    LOADING_REQUEST: 'LOADING_REQUEST'
}